import { Observable } from 'rxjs'

export class ChatFileModel {
    _id?: string
    name?: string
    type?: string
    size?: number

    handlingUpload?: Observable<any>
}



// WEBPACK FOOTER //
// ./src/models/chat-file.model.ts